import type { JSONContent } from '@tiptap/core';
import { parseMergeFieldLine } from '../MergeFieldNode';

/**
 * Processes plain text containing merge field syntax e.g. `{{ contact.first_name }}` and returns
 * the TipTap JSON model so `BasicRichTextEditor` can render merge fields without the HTML value.
 */
export const createJsonContent = (content: string): JSONContent => {
  const lines = content.split('\n');

  const paragraphs = lines.map((line) => {
    return parseMergeFieldLine(line);
  });

  return {
    type: 'doc',
    content: paragraphs,
  };
};
